import { Box, Typography } from '@mui/material';
import React from 'react';

import sourcesImage from 'assets/images/help-pdp-sources.png';
import HelpImage from 'ui/help/HelpImage';

// TODO internationalize if we end up caring about it

const HelpSources = () => {
  return (
    <Box>
      <Typography variant='body1'>
        The sources section of the product details page has information that is
        not always present in the myUNFI web application, and shows where some
        data is coming from. This is mostly useful for specific scenarios where
        you are looking for how information is sourced, and where it could be
        changed to update an item. If you are having trouble finding some piece
        of item information on this site, this may be a good place to look.
      </Typography>
      <HelpImage imageSrc={sourcesImage} alt='sources section' />
    </Box>
  );
};

export default HelpSources;
